import { CircularProgress, Grid, Paper, Typography } from "@material-ui/core";
import BackgroundImageCarousel from "../layout/background-image-carousel";
import useFederatedLogin from "./hooks/useFederatedLogin";

export const FederatedLogin = (props) => {

    const { loading, error, context } = useFederatedLogin()

    return (
        <Grid container style={{ height: '100vh' }} spacing={0}>
            <Grid item xs={false} sm={6} md={8}>
                <BackgroundImageCarousel />
            </Grid>
            <Grid item xs={12} sm={6} md={4} component={Paper} elevation={6} square>

                {error ? (
                    <>
                        <Typography
                            variant="h5"
                            gutterBottom
                            color="error"
                        >
                            Erro na autenticação
                        </Typography>

                        <Typography align="center">
                            {error}
                        </Typography>
                    </>
                ) : (
                    <>
                        <CircularProgress />

                        <Typography
                            style={{ marginTop: 24 }}
                            variant="body1"
                        >
                            Autenticando...
                        </Typography>
                    </>
                )}

                {!loading && context && (
                    <>
                        <Typography>Autenticado com sucesso!</Typography>
                        <Typography>Usuário: {context.user.name}</Typography>
                    </>
                )}
            </Grid>
        </Grid>
    )
}